var NEC_TV = {
    name: "NEC_TV",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,189,245,106,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,175,250,170,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,183,246,170,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,171,254,170,162],
        },
        {
            // function: "TV/VIDEO",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,174,253,106,162],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,182,251,106,162],
        },
        {
            function: "ANT/AUX",
            name: "ANT/AUX",
            icon: "ANT/AUX",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,171,127,106,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,190,245,90,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,175,125,90,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,183,123,90,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,171,191,90,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,187,122,218,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,173,190,218,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,181,189,218,162],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,170,223,218,162],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,189,122,186,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,174,190,186,162],
        },
        {
            function: "TIMER",
            name: "TIMER",
            icon: "TIMER",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,182,189,186,162],
        },
        {
            function: "RECALL",
            name: "RECALL",
            icon: "RECALL",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,171,95,186,162],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,52,2,52,2,52,2,156,6,64,35,160,17,52,2,76,155,59,245,170,191,234,170,162],
        },
    ]
}
export default NEC_TV